/**
 * Header interactions: Sticky scroll, Announcement bar close, Accessibility keyboard navigation
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // 1. Sticky Header & Transparency Scroll Logic
  const header = document.querySelector('[data-sticky-header]');
  
  // Throttle function for scroll performance
  let isScrolling;
  
  if (header) {
    const isStickyEnabled = header.getAttribute('data-sticky-enabled') === 'true';
    
    window.addEventListener('scroll', function() {
      window.cancelAnimationFrame(isScrolling);
      
      isScrolling = window.requestAnimationFrame(function() {
        if (window.scrollY > Math.max(50, header.offsetHeight / 2)) {
          if (isStickyEnabled || header.classList.contains('site-header--transparent')) {
            header.classList.add('site-header--scrolled');
          }
        } else {
          header.classList.remove('site-header--scrolled');
        }
      });
    });

    // Fire scroll uniformly on load
    window.dispatchEvent(new Event('scroll'));
  }

  // 2. Announcement Bar
  const annBarClose = document.querySelector('[data-announcement-close]');
  const annBar = document.querySelector('.announcement-bar');
  
  if (annBarClose && annBar) {
    annBarClose.addEventListener('click', function() {
      annBar.classList.add('is-hidden');
      // Set session storage so it stays closed during session
      sessionStorage.setItem('announcement_closed', 'true');
    });

    // Check if previously closed
    if (sessionStorage.getItem('announcement_closed') === 'true') {
      annBar.style.display = 'none';
    }
  }

  // 3. Mobile Nav Drawer Trigger
  const mobileNavTrigger = document.querySelector('[data-mobile-nav-trigger]');
  const mobileNav = document.getElementById('mobile-nav');
  const mobileNavClosers = document.querySelectorAll('[data-mobile-nav-close]');
  
  if (mobileNavTrigger && mobileNav) {
    mobileNavTrigger.addEventListener('click', () => {
      mobileNav.setAttribute('aria-hidden', 'false');
      mobileNavTrigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
    
    mobileNavClosers.forEach(closer => {
      closer.addEventListener('click', () => {
        mobileNav.setAttribute('aria-hidden', 'true');
        mobileNavTrigger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  // 4. Keyboard Accessibility for Mega Menu / Dropdowns
  const navItems = document.querySelectorAll('.site-header__nav-item');
  
  navItems.forEach(item => {
    const link = item.querySelector('.site-header__nav-link');
    const dropdown = item.querySelector('.site-header__dropdown, .site-header__mega-menu');
    
    if (link && dropdown) {
      // Allow Space/Enter to toggle without following link if it has popup
      link.addEventListener('keydown', function(e) {
        if (e.key === ' ' || e.key === 'Enter') {
          // If we want it to just open on focus-within, CSS handles it.
          // Optional: e.preventDefault(); manually toggle classes here for strictly tap-to-open
        }
      });
      
      // Close on Tab out of the entire item
      item.addEventListener('focusout', function(e) {
        if (!item.contains(e.relatedTarget)) {
           // focus fully left the menu item dropdown
        }
      });
    }
  });

});
